var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.33268H2.5M17.5 9.58268V7.33268C17.5 5.93255 17.5 5.23249 17.2275 4.69771C16.9878 4.2273 16.6054 3.84485 16.135 3.60517C15.6002 3.33268 14.9001 3.33268 13.5 3.33268H6.5C5.09987 3.33268 4.3998 3.33268 3.86502 3.60517C3.39462 3.84485 3.01217 4.2273 2.77248 4.69771C2.5 5.23249 2.5 5.93255 2.5 7.33268V14.3327C2.5 15.7328 2.5 16.4329 2.77248 16.9677C3.01217 17.4381 3.39462 17.8205 3.86502 18.0602C4.3998 18.3327 5.09987 18.3327 6.5 18.3327H8.75M13.3333 1.66602V4.99935M6.66667 1.66602V4.99935M11.6667 18.3327L13.3541 17.9952C13.5013 17.9658 13.5748 17.9511 13.6435 17.9242C13.7043 17.9003 13.7622 17.8693 13.8159 17.8319C13.8763 17.7897 13.9294 17.7367 14.0355 17.6306L17.5 14.166C17.9602 13.7058 17.9602 12.9596 17.5 12.4994C17.0398 12.0391 16.2936 12.0391 15.8333 12.4994L12.3688 15.9639C12.2627 16.07 12.2096 16.1231 12.1675 16.1835C12.1301 16.2372 12.0991 16.295 12.0752 16.3559C12.0483 16.4245 12.0336 16.4981 12.0042 16.6452L11.6667 18.3327Z",
    stroke: "#11113A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.68df288e0deffe1132a8bddc1ee9e391.svg";
export { ForwardRef as ReactComponent };